import styled from 'styled-components'
import { Box } from 'core/components/Core'

const StyledDangerBox = styled(Box)`
  background-color: #fcdee2;
`
export { StyledDangerBox }
